import * as API from '../api/Vikup';

export const loadBrands = () => {
  return API.loadBrands().then(response => {
    return response.data;
  });
}

export const loadModelsByBrandId = (brandId) => {
  return API.loadModelsByBrandId(brandId).then(response => {
    return response.data;
  });
}
